import React from 'react'
import User from '@assets/img/reservation/user.svg'
import Smile from '@assets/img/reservation/smile.svg'


const Participants = ({ form, t }) => {
    return (
        <div className="trip-reservation__participants-data">
            {form.adults.map((person, i) => (
                <div className="trip-reservation__participant-box" key={`adult-${i}`}>
                    <div className="trip-reservation__participant-title">
                        <img src={User} alt="user" />
                        {t('adult')} {i + 1}
                    </div>
                    <div className="trip-reservation__participant-name">
                        {person.name} {person.surname}
                    </div>
                    <div className="trip-reservation__participant-date">{t('birth-date')} {person.birthdate}</div>
                </div>
            ))}
            {form.children.map((person, i) => (
                <div className="trip-reservation__participant-box" key={`child-${i}`}>
                    <div className="trip-reservation__participant-title">
                        <img src={Smile} alt="smile" />
                        {t('child')} {i + 1}
                    </div>
                    <div className="trip-reservation__participant-name">
                        {person.name} {person.surname}
                    </div>
                    <div className="trip-reservation__participant-date">{t('birth-date')} {person.birthdate}</div>
                </div>
            ))}
        </div>
    )
}

export default Participants
